export default {
  Studies: "Études",
  Layouts: "Disposition de la grille",
  Sync: "Synchroniser",
  scroll: "Défilement",
  wwwc: "Niveau de la fenêtre",
  zoom: "Zoom",
  general: "Général",
  zooming: "Zoom",
  annotation: "Annotations",
  rotating: "Rotation",
  Pan: "Déplacer",
  Wwwc: "Niveaux",
  WwwcRegion: "Région de niveau",
  Magnify: "Agrandir",
  Zoom: "Zoom",
  Screen: "Capture d'écran",
  Rotate: "Rotation",
  Flip: "Retourner",
  Reset: "Réinitialiser",
  Eraser: "Gomme",
  ArrowAnnotate: "Flèche",
  Bidirectional: "Bidirectionnel",
  CobbAngle: "Angle de Cobb",
  EllipticalRoi: "Ellipse",
  EllipticalROI: "Ellipse",
  FreehandRoi: "ROI à main levée",
  Length: "Longueur",
  Probe: "Sonde",
  RectangleRoi: "Rectangle",
  TextMarker: "Marqueur de texte",
  DragProbe: "Sonde",
  ScaleOverlay: "Échelle",
  OrientationMarkers: "Repères d'orientation",
  Brush: "Pinceau",
  CircleScissors: "Ciseaux circulaires",
  FreehandScissors: "Ciseaux à main levée",
  RectangleScissors: "Ciseaux rectangulaires",
  Invert: "Inverser",
  Clip: "Film",
  Series: "Série",
  Report: "Rapport",
  patientId: "Identifiant du patient",
  fullname: "Nom complet du patient",
  birthday: "Date de naissance du patient",
  studyCreatedAt: "Date de l'étude",
  old: "Âge",
  patientSex: "Sexe",
  "Result AI": "Résultat de l'IA",
  "Download dicom": "Télécharger la série DICOM",
  "Download report": "Télécharger le rapport",
  Loading: "Chargement",
  Cached: "En cache",
  male: "Homme",
  female: "Femme",
  Copy: "Copier le texte",
  "Copy ok": "Copié",
  "Copy error": "Erreur de copie",
  Anonymized: "Anonymisé",
  StackScroll: "Défilement de la pile",
  "Result after upload message":
    "Le rapport sera disponible après le traitement par l'IA",
  "Result ai error message":
    "Échec du traitement de l'étude, veuillez essayer avec une autre étude",
  error: "Erreur",
  "dcm cannot loading": "Impossible de charger le fichier .dcm",
  "error read dcm": "Erreur de lecture des informations de l'étude",
  ai: "Série IA",
  original: "Série originale",
  "How to use title": "Guide d'utilisation",
  "How to use": "Manuel",
  "ai accept caption": "Le résultat de cette analyse de l'IA est-il correct ?",
  "thx for feedback": "Merci pour votre retour !",
  SelectedAccept: {
    1: "Vous avez noté que le résultat",
    2: "de l'analyse de l'IA est",
  },
  "accept yes": "correct",
  "accept no": "incorrect",
  "View title": "Étude | «Third Opinion»",
  Share: "Partager",
  "Share done": "Partagé",
  "Share about": "Lien copié",
  "Cancel preset": "Réinitialiser",
  Description: "Rapport",
  "About study": "Détails de l'étude",
  CheckReport: "Soumettre le rapport",
  "Your description": "Votre rapport",
  "Best description": "Rapport optimal",
  "Teacher comment": "Commentaire du professeur",
  "Answer exist": "Réponse fournie",
  "Answer not exist": "Pas de réponse",
  from: "depuis",
  "Skip all": "Tout ignorer",
  "Add screenshot": "Ajouter une capture d'écran",
  "About screen info":
    "Vous pouvez dessiner des mesures ou des régions d'intérêt dans la visionneuse et cliquer sur ce bouton. Des captures d'écran seront automatiquement jointes à votre réponse.",
  "Screenshot doned": "Capture d'écran réussie",
  PlanarFreehandROI: "ROI à main levée",
  MPR: "MPR",
  "Disable MPR First": "Désactiver MPR",
  Crosshairs: "Réticule",
  "MPR: only for 2+": "La série n'est pas reconstruite",
  "MPR: hpu tier == 0": "Le GPU de votre appareil ne prend pas en charge MPR",
  "MPR: modality not support":
    "La modalité <modality> n'est pas compatible avec MPR",
  "Cannot loading screen -- adblock":
    "Veuillez désactiver toutes les extensions de Chrome telles qu'AdBlock et Location Guard, puis réessayez",
  "Cannot loading screen -- s3 request": "Réessayez plus tard",
  "Cannot loading screen -- upload": "Réessayez plus tard",
  voi: "VOI",
  camera: "Panoramique/Zoom",
  "Remove?": "Supprimer ?",
  Support: "Assistance",
  "Support info": "Vous pouvez poser une question ou signaler un problème",
  "Send work?": "Soumettre le travail pour examen ?",
  shareAIResult:
    "Consultez le rapport d'IA sur la plateforme «Third Opinion» :",
  "Edit study": "Modifier la description de l'étude",
};
